import { render, staticRenderFns } from "./entry-phone.vue?vue&type=template&id=041174a8&"
import script from "./entry-phone.vue?vue&type=script&lang=js&"
export * from "./entry-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports